import { render } from "./EntityReport.vue?vue&type=template&id=07b690ef"
import script from "./EntityReport.vue?vue&type=script&lang=js"
export * from "./EntityReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/EntityReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07b690ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07b690ef', __exports__)) {
    console.log('reload')
    api.reload('07b690ef', __exports__)
  }
  
  module.hot.accept("./EntityReport.vue?vue&type=template&id=07b690ef", () => {
    console.log('re-render')
    api.rerender('07b690ef', render)
  })

}


export default __exports__